import { useState } from 'react'
import api from '@/services/api/cdi.js'

const useCDI = () => {

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function push(id, payload) {

		const [error, data] = await api.push(id, payload)

		if (error) {
			throw error
		}

		return data
	}

	async function pull(id, payload) {

		const [error, data] = await api.pull(id, payload)

		if (error) {
			throw error
		}

		return data
	}

	return {
		error,
		loading,
		push,
		pull,
	}

}

export default useCDI
